import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "w-full"
}
const _hoisted_2 = { class: "w-full space-y-2" }
const _hoisted_3 = { class: "flex justify-between items-center" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex justify-between items-center" }
const _hoisted_7 = { class: "flex justify-between items-center" }
const _hoisted_8 = { class: "flex justify-between items-center" }
const _hoisted_9 = { class: "flex justify-between items-center" }
const _hoisted_10 = { class: "flex justify-between items-center" }
const _hoisted_11 = {
  key: 1,
  class: "flex justify-center py-5 text-gray-500 font-bold"
}
const _hoisted_12 = { class: "flex items-center justify-between" }
const _hoisted_13 = { class: "flex items-center gap-1" }
const _hoisted_14 = { class: "flex items-center justify-between" }
const _hoisted_15 = { class: "flex items-center gap-1" }
const _hoisted_16 = { class: "flex items-center justify-between" }
const _hoisted_17 = { class: "flex items-center gap-1" }
const _hoisted_18 = { class: "flex space-x-2 justify-between mt-2" }
const _hoisted_19 = { class: "flex flex-col gap-2" }
const _hoisted_20 = { class: "d-flex justify-between" }
const _hoisted_21 = { class: "font-bold min-w-[200px] text-left" }
const _hoisted_22 = {
  key: 1,
  class: "h-full w-full justify-center flex items-center text-xl font-semibold text-gray-800 mb-4"
}

import { onMounted, ref } from 'vue';
  import { useNotification } from '@kyvg/vue3-notification';
  import { carData } from '@/types';
  import {
    formatMoney,
    localstorageGet,
    localstorageSet,
  } from '@/helpers/helper';
  import analyticsCar from '@/helpers/analytics-car';
  import moment from 'moment';
  import { getSession } from '@/indexedDB';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AnalyticsView',
  setup(__props) {

  const analytics = ref(
    JSON.parse(localstorageGet('analytics')) ?? {
      histories: [],
      avgPrice: {},
      vinCode: '',
      lotDetails: {},
    }
  );
  const { notify } = useNotification();
  const dataCar = ref<carData | null>(null);
  const source = ref<string>(localstorageGet('auctionName'));
  const loader = ref<boolean>(false);
  const visibleVinDecodeBlock = ref<boolean>(false);
  const dataForAnalitycs = ref(dataCar.value?.info?.forAnalytics ?? {});
  const carAnalytics = async () => {
    if (dataCar.value?.info?.lotId) {
      const vinResponse = await analyticsCar.getVin(
        dataCar.value.info.lotId,
        dataCar.value.info.salvageId,
        source.value
      );
      analytics.value.vinCode = vinResponse.data.vin;
      dataCar.value.info.lastFourDigits = vinResponse.data.vin.replace(
        dataCar.value.info.vim,
        ''
      );
      analytics.value.lotDetails = await analyticsCar.getLotDetails(
        vinResponse.data.vin,
        dataCar.value.info.salvageId,
        source.value
      );
      analytics.value.histories = await analyticsCar.getVinHistories(
        vinResponse.data.vin
      );
      if (dataCar.value.info.typeEng !== 'ELECTRIC') {
        dataForAnalitycs.value.engine_volume =
          dataForAnalitycs.value?.engine_volume?.match(/(\d+\.\d+)/)[0] ?? 0;
      } else {
        delete dataForAnalitycs.value.engine_volume;
      }
      analytics.value.avgBids = await analyticsCar.getAvgBids(
        dataForAnalitycs.value
      );

      analytics.value.vinDecode = await analyticsCar.getVinDecoder(
        vinResponse.data.vin
      );
      localstorageSet('analytics', JSON.stringify(analytics.value));

      notify({
        title: 'Системне повідомлення!',
        type: 'success',
        text: "Аналіз машини завершенно, можете переглянути вкладку 'Аналітика Авто'!",
      });
    } else {
      notify({
        title: 'System alert!',
        type: 'warn',
        text: 'Please parse the car on the main page!',
      });
    }
  };
  onMounted(async () => {
    loader.value = true;
    dataCar.value = await getSession('car');
    dataForAnalitycs.value = dataCar.value?.info?.forAnalytics;
    if (!analytics.value.vinCode) {
      await carAnalytics();
    }
    loader.value = false;
  });

return (_ctx: any,_cache: any) => {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Drawer = _resolveComponent("Drawer")!

  return (dataCar.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["h-full w-full flex text-xl font-semibold text-gray-800 mb-4", {
      'justify-center items-center': loader.value,
    }])
      }, [
        (loader.value)
          ? (_openBlock(), _createBlock(_component_ProgressSpinner, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_Card, null, {
                title: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("Auction Histories:")
                ])),
                content: _withCtx(() => [
                  (analytics.value.histories?.data)
                    ? (_openBlock(), _createBlock(_component_Carousel, {
                        key: 0,
                        orientation: "vertical",
                        value: analytics.value.histories?.data,
                        numVisible: 1,
                        numScroll: 1
                      }, {
                        item: _withCtx((slotProps) => [
                          _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                              _cache[3] || (_cache[3] = _createElementVNode("div", null, "Lot Number :", -1)),
                              _createElementVNode("div", null, _toDisplayString(slotProps.data.all_lots_id), 1)
                            ]),
                            _createElementVNode("div", _hoisted_4, [
                              _cache[4] || (_cache[4] = _createElementVNode("div", null, "Photos :", -1)),
                              _createElementVNode("div", null, [
                                _createElementVNode("img", {
                                  class: "h-20",
                                  src: JSON.parse(slotProps.data.photo)[0],
                                  alt: ""
                                }, null, 8, _hoisted_5)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                              _cache[5] || (_cache[5] = _createElementVNode("div", null, "Status :", -1)),
                              _createElementVNode("div", null, _toDisplayString(slotProps.data.sale_status), 1)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                              _cache[6] || (_cache[6] = _createElementVNode("div", null, "Auction :", -1)),
                              _createElementVNode("div", null, _toDisplayString(slotProps.data.auction_name), 1)
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                              _cache[7] || (_cache[7] = _createElementVNode("div", null, "Date :", -1)),
                              _createElementVNode("div", null, _toDisplayString(_unref(moment)(+slotProps.data.sale_date * 1000).format(
                        'DD.MM.YYYY'
                      )), 1)
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                              _cache[8] || (_cache[8] = _createElementVNode("div", null, "Cost :", -1)),
                              _createElementVNode("div", null, _toDisplayString(_unref(formatMoney)(slotProps.data.purchase_price)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                              _cache[9] || (_cache[9] = _createElementVNode("div", null, "Seller :", -1)),
                              _createElementVNode("div", null, _toDisplayString(slotProps.data.seller_api), 1)
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["value"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, " Auction Histories empty "))
                ]),
                _: 1
              }),
              (analytics.value.avgBids)
                ? (_openBlock(), _createBlock(_component_Card, {
                    key: 0,
                    class: "stats-card mt-2"
                  }, {
                    title: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("Last month's statistics")
                    ])),
                    content: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_12, [
                          _cache[12] || (_cache[12] = _createElementVNode("span", null, "Середня ціна", -1)),
                          _createElementVNode("span", _hoisted_13, [
                            _cache[11] || (_cache[11] = _createElementVNode("i", { class: "pi pi-arrow-up text-green-500" }, null, -1)),
                            _createTextVNode(" $ " + _toDisplayString(_unref(formatMoney)(analytics.value.avgBids.data.avg)), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _cache[14] || (_cache[14] = _createElementVNode("span", null, "Min bid", -1)),
                          _createElementVNode("span", _hoisted_15, [
                            _cache[13] || (_cache[13] = _createElementVNode("i", { class: "pi pi-arrow-down text-pink-500" }, null, -1)),
                            _createTextVNode(" $ " + _toDisplayString(_unref(formatMoney)(analytics.value.avgBids.data.min)), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _cache[16] || (_cache[16] = _createElementVNode("span", null, "Max bid", -1)),
                          _createElementVNode("span", _hoisted_17, [
                            _cache[15] || (_cache[15] = _createElementVNode("i", { class: "pi pi-arrow-up text-green-500" }, null, -1)),
                            _createTextVNode(" $ " + _toDisplayString(_unref(formatMoney)(analytics.value.avgBids.data.max)), 1)
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_18, [
                (analytics.value?.vinCode?.length > 0)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      as: "a",
                      label: "Remove Vin histories",
                      href: 
            'https://hidecars.vin/en/?vin=' +
            analytics.value?.vinCode +
            '&utm_source=liontrans&utm_medium=referral&utm_campaign=liontst1&vin_clean_offer=i9dqdvqq'
          ,
                      target: "_blank",
                      rel: "noopener"
                    }, null, 8, ["href"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Button, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (visibleVinDecodeBlock.value = true))
                }, {
                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                    _createTextVNode("Vin Decoder")
                  ])),
                  _: 1
                })
              ])
            ])),
        _createVNode(_component_Drawer, {
          visible: visibleVinDecodeBlock.value,
          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visibleVinDecodeBlock).value = $event)),
          header: "Vin Decode",
          position: "right",
          class: "!bg-gray-50"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(analytics.value.vinDecode?.data ?? {}), (decode, key) => {
                return (_openBlock(), _createElementBlock("div", { key: key }, [
                  _cache[18] || (_cache[18] = _createElementVNode("hr", { class: "mb-2" }, null, -1)),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, _toDisplayString(decode), 1),
                    _createElementVNode("div", null, _toDisplayString(analytics.value.vinDecode?.data[decode]), 1)
                  ]),
                  _cache[19] || (_cache[19] = _createElementVNode("hr", { class: "mt-2" }, null, -1))
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_22, _cache[20] || (_cache[20] = [
        _createElementVNode("div", { class: "text-center" }, [
          _createTextVNode(" This page shows analytics for the car you have parsed "),
          _createElementVNode("br"),
          _createTextVNode("You are not currently parsing the car ")
        ], -1)
      ])))
}
}

})